// extracted by mini-css-extract-plugin
export var chevron = "_d2-4";
export var chevronExpanded = "_d2-5";
export var row = "_d2-0";
export var rowBody = "_d2-6";
export var rowDescription = "_d2-7";
export var rowHeader = "_d2-1";
export var rowTitle = "_d2-2";
export var rowTitleComplete = "_d2-3";